import {
  REQUEST_REGION_REPORT,
  RECEIVE_REGION_REPORT,
  FAILURE_REGION_REPORT,
  CLEAR_REGION_REPORT,
  REQUEST_VALIDATE_REGION,
  RECEIVE_VALIDATE_REGION,
  FAILURE_VALIDATE_REGION,
  RECEIVE_REGION_REPORT_APPLICATION_EVENT,
  REQUEST_REGION_REPORT_APPLICATION_EVENT,
  FAILURE_REGION_REPORT_APPLICATION_EVENT,
  CLEAR_REGION_REPORT_APPLICATION_EVENT,
} from '../constants/actionTypes';

export function requestRegionReport({
  fieldUUID,
  seasonTag,
  geometry = [],
  includesAsAppliedApplicationData
}) {
  return {
    type: REQUEST_REGION_REPORT,
    payload: {
      fieldUUID,
      seasonTag,
      geometry,
      includesAsAppliedApplicationData
    }
  };
}

export function receiveRegionReport(regionReport) {
  return {
    type: RECEIVE_REGION_REPORT,
    payload: regionReport,
  };
}

export function failureRegionReport() {
  return {
    type: FAILURE_REGION_REPORT,
  };
}

export function clearRegionReport() {
  return {
    type: CLEAR_REGION_REPORT,
  };
}

export function requestRegionReportApplicationEvent({
  fieldUUID,
  seasonTag,
  passName,
  applicationDate,
  applicationUnits,
  applicationBuckets,
  geometry = [],
  includesAsAppliedApplicationData
}) {
  return {
    type: REQUEST_REGION_REPORT_APPLICATION_EVENT,
    payload: {
      fieldUUID,
      seasonTag,
      passName,
      applicationDate,
      applicationUnits,
      applicationBuckets,
      geometry,
      includesAsAppliedApplicationData
    }
  };
}

export function receiveRegionReportApplicationEvent(regionReportApplicationEvent) {
  return {
    type: RECEIVE_REGION_REPORT_APPLICATION_EVENT,
    payload: regionReportApplicationEvent,
  };
}

export function failureRegionReportApplicationEvent() {
  return {
    type: FAILURE_REGION_REPORT_APPLICATION_EVENT,
  };
}

export function clearRegionReportApplicationEvent() {
  return {
    type: CLEAR_REGION_REPORT_APPLICATION_EVENT,
  };
}

export function requestValidateRegion(fieldBoundary, region) {
  return {
    type: REQUEST_VALIDATE_REGION,
    fieldBoundary,
    region,
  };
}

export function receiveValidateRegion(isRegionValid) {
  return {
    type: RECEIVE_VALIDATE_REGION,
    isRegionValid,
  };
}

export function failureValidateRegion() {
  return {
    type: FAILURE_VALIDATE_REGION,
  };
}
